export default "__VITE_ASSET__B0y2gBi8__"